<template>
    <modal-component :modal_status="modal" :modal_size="'modal-lg'">
        <template v-slot:modal_header>
            <div class="modal-question custom-font-lg custom-font-bold">{{ is_edit ? 'Ubah' : 'Tambah' }} FAQ</div>
            <button type="button" class="btn-close" @click="close_modal(false)"/>
        </template>
        <template v-slot:modal_body>
            <div class="row">
                <div class="col-12 mb-3" :class="validation.firstError('form.question') ? 'custom-form-error' : ''">
                    <label class="form-label">Pertanyaan</label>
                    <textarea class="form-control custom-form-control" placeholder="Pertanyaan" v-model="form.question" rows="3"></textarea>
                    <div class="custom-form-error-message">{{ validation.firstError('form.question') }}</div>
                </div>
                <div class="col-12 mb-3" :class="validation.firstError('form.answer') ? 'custom-form-error' : ''">
                    <label class="form-label">Jawaban</label>
                    <text-editor v-model:value="form.answer" :placeholder="'Jawaban'"/>
                    <div class="custom-form-error-message">{{ validation.firstError('form.answer') }}</div>
                </div>
            </div>
        </template>
        <template v-slot:modal_footer>
            <button type="button" class="btn custom-btn-outline-02" @click="close_modal(false)">Tutup</button>
            <button type="button" class="btn custom-btn-02" @click="submit()">{{ is_edit ? 'Simpan' : 'Tambah' }}</button>
        </template>
    </modal-component>
</template>

<script>
    import ModalComponent from '@/components/external/ModalComponent'
    import TextEditor from '@/components/external/input/TextEditor'
    import { mapGetters } from 'vuex'
    import { Validator } from 'simple-vue3-validator'
    import Swal from 'sweetalert2'

	export default {
        emits: ['close'],
        components: {
            'modal-component': ModalComponent,
            'text-editor': TextEditor,
        },
        data() {
            return {
                modal: false,
                is_edit: null,
            }
        },
        computed: {
            ...mapGetters({
                form: 'faq/getFAQForm',
            }),
        },
        validators: {
            'form.question': function(value){
                return Validator.value(value).required('Wajib di isi.')
            },
            'form.answer': function(value){
                return Validator.value(value).required('Wajib di isi.')
            },
        },
        methods: {
            open_modal(value){
                if(value){
                    this.is_edit = value.id
                    this.form.question = value.question
                    this.form.answer = value.answer
                }
                this.modal = true
            },
            close_modal(value){
                this.modal = false
                this.is_edit = null
                this.validation.reset()
                this.$store.dispatch('faq/resetFAQForm')
                this.$emit('close', value)
            },
            submit(){
                let parent = this
                parent.$validate().then(function (success){
                    if(success){
                        if(parent.is_edit){
                            let data = {
                                id: parent.is_edit,
                                data: parent.form
                            }
                            parent.$store.dispatch('faq/updateFAQ', data).then((response) => {
                                if(response.status){
                                    parent.close_modal(true)
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Berhasil mengubah data',
                                        confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                        confirmButtonText: parent.$root.swal('doneButtonText'),
                                    })
                                }
                            })
                        }
                        else{
                            parent.$store.dispatch('faq/createFAQ', parent.form).then((response) => {
                                if(response.status){
                                    parent.close_modal(true)
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Berhasil menambah data',
                                        confirmButtonColor: parent.$root.swal('confirmButtonColor'),
                                        confirmButtonText: parent.$root.swal('doneButtonText'),
                                    })
                                }
                            })
                        }
                    }
                    else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: parent.$root.swal('errorValidationText'),
                            confirmButtonColor: parent.$root.swal('errorButtonColor'),
                            confirmButtonText: parent.$root.swal('errorButtonText'),
                        })
                    }
                })  
            },
        }
	}
</script>